<template>
  <div>
    <div class="kpList">
      <div>
        <div name="fade">
          <div class="kpBox" v-if="cjyhShow">
            <div>
              <div class="kpHead">
                <div>
                  <img src="../../assets/indexImg/cjyh.png" alt="中财专技" />
                </div>
                <div class="kp1">常见困惑</div>
              </div>

              <div class="kp2" v-for="item in cjyh" :key="item.id" @click="showCjyh(item)">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div name="fade">
          <div class="kpBox1" v-if="!cjyhShow">
            <div class="back" @click="cjyhShow = true">
              <div class="fleoa">
                <img class="leftImg" src="../../assets/indexImg/left_back.png" alt="中财专技" />
              </div>
              <div style="margin-left: 4px; font-size: 14px">返回列表</div>
            </div>

            <div class="kp2">{{ cjyhTitle }}</div>

            <div class="content">
              {{ cjyhContent }}
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="kpBox" v-if="kczxShow">
          <div class="kpHead">
            <div>
              <img src="../../assets/indexImg/kczx.png" alt="中财专技" />
            </div>
            <div class="kp1">课程咨询</div>
          </div>

          <div class="kp2" v-for="item in kczx" :key="item.id" @click="showkczx(item)">{{ item.title }}</div>
        </div>

        <div class="kpBox1" v-if="!kczxShow">
          <div class="back" @click="kczxShow = true">
            <div class="fleoa">
              <img class="leftImg" src="../../assets/indexImg/left_back.png" alt="中财专技" /></div>
            <div style="margin-left: 4px; font-size: 14px">返回列表</div>
          </div>

          <div class="kp2">{{ kczxTitle }}</div>

          <div class="content">
            {{ kczxContent }}
          </div>
        </div>
      </div>

      <div>
        <div class="kpBox" v-if="jyqbShow">
          <div class="kpHead">
            <div>
              <img src="../../assets/indexImg/jyqb.png" alt="中财专技" />
            </div>
            <div class="kp1">就业情报</div>
          </div>

          <div class="kp2" v-for="item in jyqb" :key="item.id" @click="showjyqb(item)">{{ item.title }}</div>
        </div>

        <div class="kpBox1" v-if="!jyqbShow">
          <div class="back" @click="jyqbShow = true">
            <div class="fleoa">
              <img class="leftImg" src="../../assets/indexImg/left_back.png" alt="中财专技" /></div>
            <div style="margin-left: 4px; font-size: 14px">返回列表</div>
          </div>

          <div class="kp2">{{ jyqbTitle }}</div>

          <div class="content">
            {{ jyqbContent }}
          </div>
        </div>
      </div>

      <div>
        <div class="kpBox" v-if="jsczShow">
          <div class="kpHead">
            <div>
              <img src="../../assets/indexImg/jscz.png" alt="中财专技" />
            </div>
            <div class="kp1">技术操作</div>
          </div>
          <div class="kp2" v-for="item in jscz" :key="item.id" @click="showjscz(item)">{{ item.title }}</div>
        </div>

        <div class="kpBox1" v-if="!jsczShow">
          <div class="back" @click="jsczShow = true">
            <div class="fleoa">
              <img class="leftImg" src="../../assets/indexImg/left_back.png" alt="中财专技" /></div>
            <div style="margin-left: 4px; font-size: 14px">返回列表</div>
          </div>

          <div class="kp2">{{ jsczTitle }}</div>

          <div class="content">
            {{ jsczContent }}
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;display: flex;justify-content: center;">
      <a
        class="btnShop"
        rel="nofollow"
        target="_blank"
        href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=中财专技"
      >
        <div>其他问题找客服</div>
        <div style="margin-left: 4px"><img src="../../assets/indexImg/jt.png" alt="中财专技" /></div>
      </a>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      cjyh: [
        {
          title: '职业培训课程学习时间会与工作冲突吗？',
          id: 1,
          content:
            '我们的职业培训采用线上自主学习和直播授课结合的方式。线上自主学习不受时间限制，学员可利用碎片化时间，如午休、下班后或周末进行学习。直播授课通常安排在晚上或周末，且提供回放，方便错过直播的学员后续学习。此外，课程学习进度可自主调整，能更好地平衡工作和学习。'
        },
        {
          title: '在线答疑多久能得到回复？',
          id: 2,
          content: '在工作日的工作时间内，我们一般会在1 - 2小时内回复您的问题。若您标注紧急，我们会优先处理，争取在30分钟内给予答复。'
        },
        {
          title: '参加培训费用多少，有优惠吗？',
          id: 3,
          content:
            '培训课程费用因课程内容、时长和授课方式而异。我们会不定期推出优惠活动，如节日折扣、满减优惠、团购优惠等。您可以关注网站活动公告。'
        },
        {
          title: '除在线答疑，还有其他沟通渠道吗？',
          id: 4,
          content:
            '除在线答疑外，您可以在课程讨论区与其他学员交流心得、分享疑问，互相学习。也可以通过电子邮件与授课讲师沟通，讲师邮箱在课程介绍页面公布。若问题复杂，还能拨打客服电话，客服人员会记录并协调解答。此外，我们还会组织线上线下交流活动，方便学员互动。'
        }
      ],
      kczx: [
        {
          title: '继续教育课程内容多久更新？',
          id: 5,
          content:
            '我们十分重视课程内容的时效性。对于热门行业课程，每年至少更新一次；像信息技术、金融等发展变化快的领域，课程内容每半年甚至更短时间就会更新。我们有专业团队关注行业动态、政策法规和新技术应用，及时调整课程内容。'
        },
        {
          title: '继续教育课程能开发票吗，是什么类型？',
          id: 6,
          content:
            '可以开具发票。您支付课程费用后，在网站个人中心提交发票申请。我们提供的是增值税电子普通发票，发票内容一般为“教育培训服务”。提交申请后，3 - 5个工作日内会开具并发送到您指定邮箱，方便报销。'
        },
        {
          title: '公需课和专业课的区别，都要学习吗？​',
          id:13,
          content:
            '公需课主要涵盖通用知识和技能，如法律法规、职业道德、信息技术等，旨在提升专业人员的综合素质。专业课则针对您的专业领域，聚焦专业知识与技术更新。一般情况下，两者都属于继续教育的要求范畴，需要按规定完成学习，具体要求可参考当地专业技术人员继续教育政策文件。'
        },
        {
          title: '课程师资力量如何，都是哪些老师授课？​',
          id: 14,
          content:
            '我们的课程主讲教师均具备副高以上职称，且在各自专业领域拥有丰富的教学与实践经验。每门课程的详情页中，都有对授课教师的详细介绍，包括教师的专业背景、所获荣誉以及过往教学成果等，您可以前往查看。'
        }
      ],
      jyqb: [
        {
          title: '如何选择自身职业发展继续教育课程？',
          id: 7,
          content:
            '首先明确职业目标，若想在当前领域晋升，选择提升专业技能深度的课程；若想转行，则选择目标行业的基础和核心课程。同时，参考行业趋势和市场需求，比如新兴热门领域的课程往往更具潜力。还可以查看课程评价和口碑，了解课程的实用性和质量。另外，结合自身时间和学习能力，避免选择过于繁重或难度过高的课程。 '
        },
        {
          title: '培训后能获得什么证书，认可度如何？',
          id: 8,
          content:
            '完成培训课程并通过考核后，您将获得结业证书，证明您在本课程领域的学习经历和成果，在行业内有一定的认可度。这些证书由国家相关部门或专业机构颁发，在求职、晋升和薪资提升等方面有很大帮助。'
        },
        {
          title: '职业培训考核方式有哪些，难通过吗？',
          id: 9,
          content: '只要认真学习课程、按时完成任务、积极参与实践，通过考核并不难，我们也会提供学习指导和复习资料。 '
        },
        {
          title: '培训后提供就业推荐服务吗？',
          id: 10,
          content: '我们与众多企业建立了合作关系，为结业学员提供就业推荐服务。'
        }
      ],
      jscz: [
        {
          title: '在线学习资源能下载离线学习吗？',
          id: 11,
          content:
            '部分课程的学习资料，如课件、文档等支持下载。但出于知识产权保护，视频课程暂不支持下载。不过，视频课程可以提前缓存，在缓存有效期内离线观看。具体下载和缓存操作方法，可在课程学习页面查看指引。'
        },
        {
          title: '在线学习平台稳定吗？',
          id: 12,
          content:
            '我们投入大量技术资源保障在线学习平台的稳定。平台采用先进服务器架构和网络技术，具备强大的并发处理能力，能满足众多学员同时在线学习。同时，我们定期维护和升级服务器，及时修复问题。若您遇到卡顿、掉线等情况，可联系技术支持团队，我们会迅速解决。'
        },
        {
          title: '课程视频无法播放，怎么办？​',
          id: 15,
          content:
            '首先，请检查您的网络连接是否正常，可尝试刷新页面或更换网络环境。若网络正常，可能是浏览器不兼容问题，建议您更换为 Chrome、Firefox 等主流浏览器。若仍无法播放，可能是课程视频资源出现故障，请您联系客服，我们会及时排查修复。'
        },
        {
          title: '忘记登录密码，如何找回？​',
          id: 16,
          content:
            '在网站登录页面，点击 “忘记密码” 按钮。您可以通过注册时绑定的手机号码或邮箱，接收验证码进行密码重置。若您的绑定信息有误或无法接收验证码，请联系网站客服，提供您的注册账号及相关身份信息，客服人员会协助您处理。'
        }
      ],
      cjyhShow: true,
      cjyhContent: '',
      cjyhTitle: '',
      kczxShow: true,
      kczxContent: '',
      kczxTitle: '',
      jyqbShow: true,
      jyqbContent: '',
      jyqbTitle: '',
      jsczShow: true,
      jsczContent: '',
      jsczTitle: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    showCjyh(item) {
      this.cjyhTitle = item.title;
      this.cjyhContent = item.content;
      this.cjyhShow = false;
    },
    showkczx(item) {
      this.kczxTitle = item.title;
      this.kczxContent = item.content;
      this.kczxShow = false;
    },
    showjyqb(item) {
      this.jyqbTitle = item.title;
      this.jyqbContent = item.content;
      this.jyqbShow = false;
    },
    showjscz(item) {
      this.jsczTitle = item.title;
      this.jsczContent = item.content;
      this.jsczShow = false;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 52px;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
}
.kpList {
  width: 1400px;
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
  .kpBox {
    width: 320px;
    height: 370px;
    background: linear-gradient(180deg, #e5edff 0%, #f9fbff 25%);
    box-shadow: 0px 5px 20px 0px rgba(113, 114, 117, 0.12);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
    padding: 30px 25px;
    .kpHead {
      display: flex;
      align-items: center;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(64, 118, 246, 0.1);
      .kp1 {
        margin-left: 8px;
        font-size: 18px;
        margin-bottom: 4px;
      }
    }

    .kp2 {
      padding: 15px 10px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-top: 10px;
      cursor: pointer;
    }
    .kp2:hover {
      background: rgba(64, 118, 246, 0.15);
      border-radius: 10px 10px 10px 10px;
      color: #4076f6;
    }
  }
  .kpBox1 {
    width: 320px;
    height: 370px;
    background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
    box-shadow: 0px 5px 20px 0px rgba(113, 114, 117, 0.12);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
    padding: 30px 25px;
    opacity: 0.8;
    .back {
      height: 22px;
      display: flex;
      align-content: center;
      color: #fff;

      cursor: pointer;
      .fleoa {
        position: relative;
        width: 16px;
        height: 16px;
        .leftImg {
          position: absolute;
          top: 2px;
          left: 0;
          width: 16px;
          height: 16px;
        }
      }
        
    }
    .kp2 {
      margin-top: 15px;
      padding: 15px 10px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 10px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px 10px 10px 10px;
      color: #fff;
    }
    .content {
      margin-top: 20px;
      color: #fff;
      font-size: 14px;
      height: 220px;
      overflow-y: scroll;
    }
    /* 滚动条样式 */
    .content::-webkit-scrollbar {
      width: 1px;
      /*  设置纵轴（y轴）轴滚动条 */
      height: 2px;
      /*  设置横轴（x轴）轴滚动条 */
    }

    /* 滚动条滑块（里面小方块） */
    .content::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: #fff;
    }

    /* 滚动条轨道 */
    .content::-webkit-scrollbar-track {
      border-radius: 0;
      background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
    }
  }
}
</style>
